<template>
    <v-card>
        <v-card-title>Поддержка</v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <h5>Телефон поддержки: <a href="tel:8(800)700-09-54">8 800 700-09-54</a></h5>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <transition name="fade" mode="out-in" appear>
                <v-row v-if=" ! request.number " key="form">
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12">
                                <h5 class="mb-0">Или напишите нам обращение. Мы ответим в течение 24 часов:</h5>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col cols="12" offset="2">
                                <v-form
                                    @submit.prevent="onSubmit"
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    v-model="form.name.value"
                                                    :name="form.name.name"
                                                    :rules="form.name.rules"
                                                    label="Ваше имя"
                                                    placeholder="Введите Ваше имя"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    :name="form.email.name"
                                                    v-model="form.email.value"
                                                    :rules="form.email.rules"
                                                    label="Ваш email"
                                                    placeholder="Ваш email для ответа"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="8">
                                                <v-textarea
                                                    outlined
                                                    label="Причина обращения"
                                                    placeholder="Опишите Вашу проблему"
                                                    :name="form.description.name"
                                                    :rules="form.description.rules"
                                                    :value="form.description.value"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                        <v-btn
                                            color="success"
                                            type="submit"
                                            :disabled="!valid || isFetching"
                                        >
                                        Отправить
                                        </v-btn>
                                    </v-container>
                                </v-form>
                            </v-col>
                        </v-row>
                </v-col>
                </v-row>
                <v-row v-else key="result">
                    <v-col cols="12">
                        <v-row justify="center">
                            <h5><v-icon color="success" x-large>mdi-check-circle-outline</v-icon> Ваше обращение успешно создано! Номер обращения #{{request.number}}</h5>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-btn color="primary" @click="onCreateAnother">Создать еще обращение</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </transition>
        </v-card-text>
    </v-card>
</template>
  
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>
<script>
import {mapGetters, mapActions} from 'vuex';
import axios from '@/plugins/axios';
  export default {
    components: {},
    name: 'SupportPage',
    props:{
    },
    data() {
      return {
        request: {
            number: null
        },
        valid: false,
        isFetching: false,
        form: {
            name: {
                value: '',
                name: 'user_name',
                rules: [ v => !!v || 'Обязательно для заполнения',]
            },
            email: {
                value: '',
                name: 'email',
                rules: [
                    v => !!v || 'Обязательно для заполнения',
                    v => /.+@.+/.test(v) || 'Не валидный email',
                ]
            },
            description: {
                value: '',
                name: 'message',
                rules: [ v => !!v || 'Обязательно для заполнения',]
            },
        }
      }
    },
    created() {
        this.form.name.value = this.authUserName;
        this.form.email.value = this.authUserEmail;
    },
    methods: {
        ...mapActions('notifications', ['SHOW_ERROR']),
        onSubmit(){
            if( ! this.$refs.form.validate() ){
                return;
            }
            this.isFetching = true;
            this.send(new FormData(this.$refs.form.$el)).then(res => {
                this.request.number = res.data.id;
            }).catch(err => {
                console.log(err);
                this.SHOW_ERROR('Произошла ошибка создания запроса. Повторите попытку.');
            }).finally(() => {
                this.isFetching = false;
            });
        },

        async send(data){
            let response = await axios.post('support-requests', data);
            return response
        },

        resetForm () {
            this.form.description.value = '';
        },
        onCreateAnother(){
            this.request.number = null;
        }
    },
    computed:{
        ...mapGetters('user', {authUserEmail: 'EMAIL', authUserName: 'USER_NAME'}),
    }
  }
  </script>